import { useTranslation } from 'react-i18next';

/**
 * Название формата задания на языке интерфейса.
 *
 * ЗАЧЕМ ОДИН ИСТОЧНИК. Раньше подписи лежали ДВУМЯ русскими списками — в
 * `api/ieltsMock.ts` и внутри страницы тренажёра, — и они успели разойтись:
 * один и тот же `short_answer` назывался то «Краткий ответ», то «Короткий
 * ответ», а `mc_single` — «Выбор одного ответа» и «Выбор одного варианта».
 * Ученик видел разные слова про одно и то же в моке и в тренажёре.
 *
 * Незнакомый ключ возвращается как есть: в пул может приехать новый тип
 * раньше, чем мы добавим ему подпись, и лучше показать сырое имя, чем пустоту.
 */
export function useIeltsTypeLabel(): (type: string) => string {
  const { t } = useTranslation();
  return (type: string) => t(`ielts.type.${type}`, type);
}
